var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-session"},[_c('VSvgIcon',{attrs:{"data-testid":"app-session-logo","icon":_vm.channel.logo || '',"tag":"24"}}),_c('span',{staticClass:"app-session__text"},[_vm._v("\n   "+_vm._s(_vm.message.text)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }